<template>
  <div class="text-center">
    <b-spinner variant="danger" type="grow" label="Spinning" style="width: 3rem; height: 3rem;"></b-spinner>
  </div>
</template>
<script>
export default {
  name: "Loader2"
};
</script>
